export default __webpack_public_path__ + "static/desarrollamos-7a88ae27d1f1cdad8ca62a1a1b9b1656.png";